import axios from '@/config/axios';

const state = {
    order: '',
    orders: [],
    getTableOrders: []
};

const getters = {
    getOrder: state => state.order,
    getOrders: state => state.orders,
    getTableOrders: state => state.orders,
}
const mutations = {
    setOrder(state, order) {
        state.order = order
    },
    setOrders(state, orders) {
        state.orders = orders
    },
    setTableOrders(state, orders) {
        state.orders = orders
    }
}
const actions = {
    store: async ({commit, dispatch}, params) => {
        try {
            const response = await axios.post('/orders', params);
            commit('orders/setOrder', response.data.order, {root: true});
            commit('errors/setMessage', response.data.message, {root: true});
            commit('payments/setStripe', response.data.stripe, {root: true});
        } catch (e) {
            commit('orders/setOrder', '', {root: true});
            commit('payments/setStripe', '', {root: true});
            await dispatch('errors/errorResponse', e.response, {root: true});
        }
    },
    all: async ({commit, dispatch}, params) => {
        try {
            const response = await axios.get('orders?page=' + params.page);
            commit('orders/setOrders', response.data.orders, {root: true});
            commit('orders/setTableOrders', response.data.orders.data, {root: true});

        } catch (e) {
            await dispatch('errors/errorResponse', e.response, {root: true});
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
